export const roleDefault = () => {
    return {
        id: null,
        name: null,
        costs: null,
        stocks: null,
        permissions: []
    }
}

export default {
    role: roleDefault(),
    permissions: [],
    categories: [],
    categories_specials: {
      selected:null,
    },
    permissions_specials: [],
    category: {
      selected:null
    },
    copyPermissions: [],
    roles: [],
    actionForm: 'create',
    users:[],
    params: {
        page: 1,
        perPage: 15,
        name:''

      },


}



// WEBPACK FOOTER //
// ./src/modules/roles/state.js